








































































import { computed, defineComponent, nextTick, ref, PropType } from '@vue/composition-api';
import { getImgSrcByEnv, imgSrcPrefix, logger, getUrlFromImageInfoOrVideoInfo } from '@tt4b/ttam-utils';
import { MaterialSize, VideoCover, AdgroupFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import { useGetVideoCoverListApi } from '@tt4b/ttam-hooks';
import ImageUpload from '../image-upload/index.vue';

const name = 'ttam-video-cover-change';

export default defineComponent({
  name,

  components: { ImageUpload },

  props: {
    adgroupData: {
      required: true,
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      required: true,
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
  },

  setup(props, ctx) {
    const visible = ref(false);
    const loading = ref(false);
    const selectedIndex = ref(0);
    const coverList = ref<VideoCover[]>([]);
    const coverListContainerNode = ref();

    /** 设置上传封面裁剪长宽类型 */
    const coverMode = ref([MaterialSize.Horizontal]);
    const setCoverMode = () => {
      const firstItem = coverList.value[0];
      logger.debug('set image cropper', firstItem);
      coverMode.value = firstItem?.width > firstItem?.height ? [MaterialSize.Horizontal] : [MaterialSize.Vertical720];
    };

    const dialogWidth = computed(() => {
      const firstItem = coverList.value[0];
      return firstItem?.width > firstItem?.height ? '808px' : '680px';
    });

    /** 封面上传逻辑相关 */
    const coverUploadNode = ref();
    const startUpload = () => coverUploadNode.value?.startUpload();
    const uploadCover = () => nextTick(() => startUpload());
    const onUploadCoverSuccess = cover => {
      coverList.value.push(cover[0]);
      selectedIndex.value = coverList.value.length - 1;
      setTimeout(() => {
        coverListContainerNode.value?.lastElementChild?.scrollIntoView({
          behavior: 'smooth',
        });
      }, 200);
    };

    function open(vid: string, uri?: string) {
      if (!vid) {
        return;
      }
      loading.value = true;
      visible.value = true;
      useGetVideoCoverListApi(vid)
        .then(data => {
          coverList.value = data;
          setCoverMode();
          selectedIndex.value = coverList.value.findIndex(cover => cover.webUri === uri);
        })
        .catch(() => {
          coverList.value = [];
        })
        .finally(() => {
          loading.value = false;
        });
    }

    function close() {
      visible.value = false;
      coverList.value = [];
      selectedIndex.value = 0;
    }

    function select(index) {
      selectedIndex.value = index;
    }

    function confirm() {
      const selectedCover = coverList.value[selectedIndex.value];
      ctx.emit('confirm', selectedCover);
      close();
    }

    return {
      name,
      loading,
      visible,
      coverList,
      selectedIndex,
      dialogWidth,

      coverMode,
      coverUploadNode,
      coverListContainerNode,
      uploadCover,
      getImgSrcByEnv,
      imgSrcPrefix,
      getUrlFromImageInfoOrVideoInfo,
      onUploadCoverSuccess,

      open,
      close,
      select,
      confirm,
    };
  },
});
